// import { UIkit, Icons } from "franken-ui/uikit/js/dist";
import "./htmx.js";
import Alpine from "alpinejs";
import "../scss/app.scss";
import "franken-ui/js/core.iife";
import UIkit from "franken-ui/js/core.iife";
import "franken-ui/js/icon.iife";
// import { Centrifuge } from "centrifuge";
import "@lottiefiles/dotlottie-wc";

window.UIkit = UIkit;

// UIkit.use(Icons);

// window.UIkit = UIkit;
window.Alpine = Alpine;
// window.centrifuge = Centrifuge;

Alpine.start();
